// extracted by mini-css-extract-plugin
module.exports = {"body":"_2_ohZeGF","radioButton":"_3JUxC-Gi","optionText":"_2b-2q6Ov","separator":"_1kaINGIz"};